import useGeoLocation from '@api/hooks/useGeoLocation';
import constants from '@cont/Login/constants';
import useLoginStore from '@stores/login/loginStore';
import { getOTPSender } from '@stores/selectors/login';
import { useCallback } from 'react';
import useIsOutsideIndiaFlow from './useIsOutsideIndiaFlow';

const useSubmitEmail = ({
  country,
  email,
  setNumberStepErrorMsg,
  setAccountType
}) => {
  const { geoLocationData: { countryCode } = {} } = useGeoLocation();
  const isOutsideIndiaFlow = useIsOutsideIndiaFlow();

  const sendOtpOrEmail = useLoginStore(getOTPSender);

  return useCallback(() => {
    sendOtpOrEmail({
      countryCode: countryCode || country?.code,
      otpType: 1,
      email
    }).then((response) => {
      if (response?.error) return setNumberStepErrorMsg(response.error.message);
      // Use the register outside India flow in order to sign up the user using their email.
      if (!response?.is_registered && isOutsideIndiaFlow)
        setAccountType(constants.ACCOUNT_TYPE_SIGNUP);
    });
  }, [
    sendOtpOrEmail,
    country?.code,
    countryCode,
    email,
    setNumberStepErrorMsg,
    setAccountType,
    isOutsideIndiaFlow
  ]);
};

export default useSubmitEmail;
